import { render, staticRenderFns } from "./Advisory.vue?vue&type=template&id=1765d0d9"
import script from "./Advisory.vue?vue&type=script&lang=js"
export * from "./Advisory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports